import { ICellRendererParams } from '@ag-grid-community/core';

import './BtnApprovalRenderer.css';

const BtnApprovalRenderer = (props: ICellRendererParams) => {
    return (
      <img src="images/approve.svg" className="grid_approval_btn" alt="approval button" />
    );
  };
 
export default BtnApprovalRenderer;